__turbopack_context__.v({
  "AccordionButton": "fEXajq_AccordionButton",
  "Container": "fEXajq_Container",
  "Description": "fEXajq_Description",
  "Detail": "fEXajq_Detail",
  "Image": "fEXajq_Image",
  "Links": "fEXajq_Links",
  "Root": "fEXajq_Root",
  "Root--DetailsOpen": "fEXajq_Root--DetailsOpen",
  "Root--HasDetails": "fEXajq_Root--HasDetails",
  "Text": "fEXajq_Text",
  "Title": "fEXajq_Title",
  "skeleton-loading": "fEXajq_skeleton-loading",
});
